import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const FittingState = Immutable.fromJS({
	alertStyle: null,
	alertMessage: null,
	orderId: '',
	allOrderIds: [],
	eventKey: 0,
	detailsNeedBespoke: [],
	showFittingOrdererModal: false,
	showFittingRecordModal: false,
	showFittingBatchModal: false,
	orderer: {
		orderId: '',
		ordererId: '',
		category: '',
		firefighterCorporation: '',
		firefighterDivision: '',
		firefighterSquadron: '',
		firefighterType: '',
		firefighterTitle: '',
		firefighterName: '',
		suitCount: '1',
		remark: '',
		displayName: ''
	},
	ordererValidation: {
		category: {
			validationState: null,
			helpBlock: null
		},
		firefighterCorporation: {
			validationState: null,
			helpBlock: null
		},
		firefighterDivision: {
			validationState: null,
			helpBlock: null
		},
		firefighterSquadron: {
			validationState: null,
			helpBlock: null
		},
		firefighterType: {
			validationState: null,
			helpBlock: null
		},
		firefighterTitle: {
			validationState: null,
			helpBlock: null
		},
		firefighterName: {
			validationState: null,
			helpBlock: null
		},
		suitCount: {
			validationState: null,
			helpBlock: null
		},
		remark: {
			validationState: null,
			helpBlock: null
		},
	},
	fittingRecord: {
		suit_id: '',
		itemsCount: 0
	},
	batch: {
		orderId: '',
		category: '',
		firefighterCorporation: '',
		firefighterDivision: '',
		firefighterSquadron: '',
		firefighterType: '',
		orderDetailId: '',
		batchBespokeDetail: null,
		displayName: '',
		quantity: '',
		isSpareParts: false,
		_color: '',
		_sizing: '',
		_note: '',
	},
	batchValidation: {
		category: {
			validationState: null,
			helpBlock: null
		},
		firefighterCorporation: {
			validationState: null,
			helpBlock: null
		},
		firefighterDivision: {
			validationState: null,
			helpBlock: null
		},
		firefighterSquadron: {
			validationState: null,
			helpBlock: null
		},
		firefighterType: {
			validationState: null,
			helpBlock: null
		},
		orderDetailId: {
			validationState: null,
			helpBlock: null
		},
		quantity: {
			validationState: null,
			helpBlock: null
		},
		_color: {
			validationState: null,
			helpBlock: null
		},
		_sizing: {
			validationState: null,
			helpBlock: null
		},
		_note: {
			validationState: null,
			helpBlock: null
		},
	},
	statOverviewCount: [],
	statDetailDataList: null,
	showForceUpload: 'none'
});

const fittingReducer = handleActions({
	CHANGE_FITTING_ORDERID: (state, { payload }) => {
		let orderer = state.get('orderer');
		let batch = state.get('batch');
		return state.merge({
			orderId: payload.orderId,
			orderer: orderer.set('orderId', payload.orderId),
			batch: batch.set('orderId', payload.orderId),
		})
	},
	FIND_ALL_ORDERIDS: (state, { payload }) => {
		return state.merge({
			allOrderIds: payload.data
		})
	},
	OPEN_FITTING_ORDERER_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showFittingOrdererModal: true
		})
	},
	CLOSE_FITTING_ORDERER_MODAL: (state, { payload }) => {
		let orderId = state.get('orderId');
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			showFittingOrdererModal: false,
			orderer: {
				orderId: orderId,
				ordererId: '',
				category: '',
				firefighterCorporation: '',
				firefighterDivision: '',
				firefighterSquadron: '',
				firefighterType: '',
				firefighterTitle: '',
				firefighterName: '',
				suitCount: '1',
				remark: '',
				displayName: ''
			},
			ordererValidation: {
				category: {
					validationState: null,
					helpBlock: null
				},
				firefighterCorporation: {
					validationState: null,
					helpBlock: null
				},
				firefighterDivision: {
					validationState: null,
					helpBlock: null
				},
				firefighterSquadron: {
					validationState: null,
					helpBlock: null
				},
				firefighterType: {
					validationState: null,
					helpBlock: null
				},
				firefighterTitle: {
					validationState: null,
					helpBlock: null
				},
				firefighterName: {
					validationState: null,
					helpBlock: null
				},
				suitCount: {
					validationState: null,
					helpBlock: null
				},
				remark: {
					validationState: null,
					helpBlock: null
				},
			},
		})
	},
	CLEAR_FITTING_ORDERER_ALERT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			ordererValidation: {
				category: {
					validationState: null,
					helpBlock: null
				},
				firefighterCorporation: {
					validationState: null,
					helpBlock: null
				},
				firefighterDivision: {
					validationState: null,
					helpBlock: null
				},
				firefighterSquadron: {
					validationState: null,
					helpBlock: null
				},
				firefighterType: {
					validationState: null,
					helpBlock: null
				},
				firefighterTitle: {
					validationState: null,
					helpBlock: null
				},
				firefighterName: {
					validationState: null,
					helpBlock: null
				},
				suitCount: {
					validationState: null,
					helpBlock: null
				},
				remark: {
					validationState: null,
					helpBlock: null
				},
			},
		})
	},
	CHANGE_FITTING_EVENT_KEY: (state, { payload }) => {
		return state.merge({
			eventKey: payload
		})
	},
	CHANGE_ORDERER_VALUE: (state, { payload }) => {
		let orderer = state.get('orderer');
		return state.merge({
			orderer: orderer.set(payload.id, payload.value),
		})
	},
	CHANGE_FITTING_RECORD_VALUE: (state, { payload }) => {
		let fittingRecord = state.get('fittingRecord');
		return state.merge({
			fittingRecord: fittingRecord.set(payload.id, payload.value),
		})
	},
	ADD_ORDERER: (state, { payload }) => {
		return state.merge({
			orderer: payload.data.bean,
			ordererValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_ORDERER: (state, { payload }) => {
		return state.merge({
			orderer: payload.data
		})
	},
	EDIT_ORDERER: (state, { payload }) => {
		return state.merge({
			orderer: payload.data.bean,
			ordererValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_DETAILS_NEED_BESPOKE: (state, { payload }) => {
		return state.merge({
			detailsNeedBespoke: payload.data
		})
	},
	OPEN_FITTING_RECORD_MODAL: (state, { payload }) => {
		return state.merge({
			showFittingRecordModal: true
		})
	},
	CLOSE_FITTING_RECORD_MODAL: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			showFittingRecordModal: false,
			fittingRecord: {
				suit_id: '',
				itemsCount: 0
			},
		})
	},
	FIND_FITTING_RECORD: (state, { payload }) => {
		return state.merge({
			fittingRecord: payload.data
		})
	},
	EDIT_FITTING_RECORD: (state, { payload }) => {
		if (payload.statusCode === '0') {
			return state.merge({
				alertStyle: null,
				alertMessage: null,
				showFittingRecordModal: false,
				fittingRecord: {
					suit_id: '',
					itemsCount: 0
				},
			})
		} else {
			return state.merge({
				fittingRecord: payload.data.bean,
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
			})
		}
	},
	DELETE_FITTING_RECORD: (state, { payload }) => {
		if (payload.statusCode === '0') {
			return state.merge({
				alertStyle: null,
				alertMessage: null,
				showFittingRecordModal: false,
				fittingRecord: {
					suit_id: '',
					itemsCount: 0
				},
			})
		} else {
			return state.merge({
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
			})
		}
	},
	DELETE_FITTING_RECORD_ITEM: (state, { payload }) => {
			return state.merge({
				fittingRecord: payload.data.bean,
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
			})
	},
	OPEN_FITTING_BATCH_MODAL: (state, { payload }) => {
		return state.merge({
			showFittingBatchModal: true
		})
	},
	CLOSE_FITTING_BATCH_MODAL: (state, { payload }) => {
		let orderId = state.get('orderId');
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			showFittingBatchModal: false,
			batch: {
				orderId: orderId,
				category: '',
				firefighterCorporation: '',
				firefighterDivision: '',
				firefighterSquadron: '',
				firefighterType: '',
				orderDetailId: '',
				batchBespokeDetail: null,
				displayName: '',
				quantity: '',
				isSpareParts: false,
				_color: '',
				_sizing: '',
				_note: '',
			},
			batchValidation: {
				category: {
					validationState: null,
					helpBlock: null
				},
				firefighterCorporation: {
					validationState: null,
					helpBlock: null
				},
				firefighterDivision: {
					validationState: null,
					helpBlock: null
				},
				firefighterSquadron: {
					validationState: null,
					helpBlock: null
				},
				firefighterType: {
					validationState: null,
					helpBlock: null
				},
				orderDetailId: {
					validationState: null,
					helpBlock: null
				},
				quantity: {
					validationState: null,
					helpBlock: null
				},
				_color: {
					validationState: null,
					helpBlock: null
				},
				_sizing: {
					validationState: null,
					helpBlock: null
				},
				_note: {
					validationState: null,
					helpBlock: null
				},
			},
		})
	},
	CHANGE_FITTING_BATCH_VALUE: (state, { payload }) => {
		let batch = state.get('batch');
		return state.merge({
			batch: batch.set(payload.id, payload.value),
		})
	},
	ADD_BATCH_ITEMS: (state, { payload }) => {
		return state.merge({
			batch: payload.data.bean,
			batchValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_FITTING_DASHBOARD: (state, { payload }) => {
		return state.merge({
			statOverviewCount: payload.data.statOverviewCount,
			statDetailDataList: payload.data.statDetailDataList,
		})
	},
	FITTING_DEFAULT_VALIDATE_FAIL: (state, { payload }) => {
		return state.merge({
			alertStyle: 'danger',
			alertMessage: payload.displayMessage,
		})
	},
	BEFORE_UPLOAD_ORDERER_DATA: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: '資料處理中，請稍後。'
		})
	},
	AFTER_UPLOAD_ORDERER_DATA: (state, { payload }) => {
		let showForceUpload = 'none';
		let alertMessage = payload.data.alertMessage;
		if (alertMessage.startsWith('訂購人重覆')) {
			showForceUpload = '';
		}
		return state.merge({
			alertStyle: payload.data.alertStyle,
			alertMessage: alertMessage,
			showForceUpload: showForceUpload
		})
	},
	DELETE_BY_DURATION: (state, { payload }) => {
		return state.merge({
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
}, FittingState);

export default fittingReducer;


// WEBPACK FOOTER //
// ./src/reducers/fittingReducer.js